import { useState as m } from "react";
import { useTimer as p } from "./use-timer.mjs";
const y = {
  size: 20,
  overrideLastItemDebounceMS: -1
  // overriding is disabled by default
};
function M(l, v) {
  const { size: b, overrideLastItemDebounceMS: a, onChange: t } = {
    ...y,
    ...v
  }, [o, n] = m(l), [i, f] = m([o]), [r, u] = m(0), L = p();
  return [o, (e, s) => {
    if (
      // compare entries if passed value is object
      typeof e == "object" && Object.entries(e).toString() === Object.entries(o).toString() || e === o
    )
      return;
    const I = a > 0, S = L.check(), O = I && S !== void 0 ? S > a : !0;
    if (
      // use value of config.overrideLastItem if passed
      (s == null ? void 0 : s.overrideLastItem) !== void 0 ? s.overrideLastItem : !O
    )
      f((c) => [...c.slice(0, r), e]);
    else {
      const c = i.length >= b;
      f((d) => [...d.slice(c ? 1 : 0, r + 1), e]), c || u((d) => d + 1);
    }
    n(e), t == null || t(e);
  }, () => {
    if (r <= 0)
      return { success: !1 };
    const e = i[r - 1];
    return e === void 0 ? { success: !1 } : (n(e), u((s) => s - 1), t == null || t(e), { success: !0, value: e });
  }, () => {
    if (r + 1 >= i.length)
      return { success: !1 };
    const e = i[r + 1];
    return e === void 0 ? { success: !1 } : (n(e), u((s) => s + 1), t == null || t(e), { success: !0, value: e });
  }];
}
export {
  M as useHistoryState
};
